<template>
  <div class="device-measurments-view">
    <v-container>
      <v-row>
        <v-col cols="12">
          <h1>Device Data</h1>
          <p>Gestión de datos de dispositivos</p>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <v-data-table
            :headers="headers"
            :items="deviceMeasurementsList"
            :loading="loading"
            class="elevation-1"
          >
            <template v-slot:top>
              <v-toolbar flat>
                <v-toolbar-title>Lista de Datos de Dispositivos</v-toolbar-title>
                <v-divider class="mx-4" inset vertical></v-divider>
                <v-spacer></v-spacer>
                <v-btn color="primary" @click="refreshData">
                  <v-icon left>mdi-refresh</v-icon>
                  Actualizar
                </v-btn>
              </v-toolbar>
            </template>
            <template v-slot:item.time="{ item }">
              {{ formatDate(item.time) }}
            </template>
            <template v-slot:item.validated="{ item }">
              <v-chip :color="item.validated ? 'success' : 'error'" small>
                {{ item.validated ? 'Validado' : 'No validado' }}
              </v-chip>
            </template>
            <template v-slot:item.actions="{ item }">
              <v-icon small class="mr-2" @click="editItem(item)">
                mdi-pencil
              </v-icon>
              <v-icon small @click="deleteItem(item)">
                mdi-delete
              </v-icon>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted, computed } from 'vue'
import { useDeviceMeasurementsStore } from './store'
import { DeviceMeasurements } from './models/deviceMeasurements'

const deviceMeasurementsStore = useDeviceMeasurementsStore()
const loading = ref(false)

const headers = [
  { title: 'ID', key: 'id' },
  { title: 'Tiempo', key: 'time' },
  { title: 'Dispositivo ID', key: 'deviceId' },
  { title: 'Sensor ID', key: 'sensorId' },
  { title: 'Validado', key: 'validated' },
  { title: 'Valor', key: 'value' },
  { title: 'Texto Valor', key: 'valueText' },
  { title: 'Acciones', key: 'actions', sortable: false },
]

const deviceMeasurementsList = computed(() => deviceMeasurementsStore.deviceMeasurements)

const formatDate = (date: Date | string) => {
  return new Date(date).toLocaleString('es-ES')
}

const refreshData = async () => {
  loading.value = true
  try {
    await deviceMeasurementsStore.getDeviceMeasurements()
  } finally {
    loading.value = false
  }
}

const editItem = (item: DeviceMeasurements) => {
  // Implementar lógica de edición
  console.log('Edit item:', item)
}

const deleteItem = (item: DeviceMeasurements) => {
  // Implementar lógica de eliminación
  console.log('Delete item:', item)
}

onMounted(() => {
  refreshData()
})
</script>

<style scoped>
.device-measurements-view {
  height: 100%;
}
</style>
